var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-event-calendar',{attrs:{"events":_vm.demoEvents},on:{"monthChanged":_vm.monthChange,"dayChanged":_vm.dayChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }